/**
 * description: 
 * this is the coolest modal to use at Tradera.com. the width of the content of this modal 
 * decides how big this modal should be.
 * 
 * Important: the "bp" class needs to exist as a parent before using the Modal component.
 * To use this modal
 * <ModalContainer>
 *    <ModalHeader>Header Text</ModalHeader>
 *    <ModalBody>This is the body</ModalBody>
 *    <ModalFooter>This is my footer</ModalFooter>
 * </ModalContainer>

 */

import React, { Fragment } from 'react';
import PropType from 'prop-types';
import './modal.scss';

const ModalContainer = ({ children, className = '' }) => {
    return (
        <Fragment>
            <div
                className={`tr-modal-container d-flex flex-column justify-content-between w-100 w-md-75 m-auto ${className}`}
                onClick={e => {
                    e.stopPropagation();
                }}>
                {children}
            </div>
        </Fragment>
    );
};

ModalContainer.propTypes = {
    children: PropType.node.isRequired,
    className: PropType.string
};

export default ModalContainer;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/modals/modal-container.jsx